import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
// import FillColorSelector from 'components/Tools/FillColorSelector';
import { useStore, StoreTypes } from "context";
import Repository from "repositories/Repository";
import useSetState from "customHooks/setState";
import {
  ScrollPositionType,
  ScrollDirection,
  ScrollLabel,
} from "constants/scrollPositionType";
import { EventBusType } from "events/EventBus";
import { EventBus } from "events/EventBus";
import { ReaderToolsEvent } from "events/EventTypes";
import { ScrollLength,ScrollCoordinate } from "constants/scrollPositionType";
import {scrollPositionButtonBehavior} from '../ExtendedContentScrollPositionButton'
import {ReaderToolType} from 'constants/ReaderTools'
import classnames from "classnames";
import { SplitType } from "constants/splitType";

const { ExtendedResourceRepository } = Repository;

const eventBusType = EventBusType.ExtendedContent;

export const ExtendedContentButton = (props) => {
  const html =
    props.el.props && props.el.props.html ? props.el.props.html : false;
  const synopsisInfo =
    props.el.props && props.el.props.synopsisInfo
      ? props.el.props.synopsisInfo
      : false;

  // to do...
  const styleVersion = props.el.props
    ? props.el.props.extendedResourceStyle
    : null;
  const schoolYear = styleVersion
    ? styleVersion.split("_").includes("108")
    : false;
  const semester = styleVersion ? styleVersion.split("_").includes("2") : false;

  const [{ bookId }] = useStore(StoreTypes.books);
  const [{ scrollPosition, scrollPositionButtonState, fontSize, currentPage, splitType }] = useStore(StoreTypes.extendedContent);
  const { list } = synopsisInfo ? synopsisInfo : {};
  const [{ synopsisList, template }, setState] = useSetState({
    template: "",
    synopsisList: [],
  });
  

  // --- 小視窗上下移動相關
  const [contentDirection, setContentDirection] = useState(
    ScrollDirection.Vertical
  ); // 小視窗上下頁移動方向
  const [currentScrollLeft, setCurrentScrollLeft] = useState(0);
  const [lastScrollLeft, setLastScrollLeft] = useState(0);
  const [currentScrollTop, setCurrentScrollTop] = useState(0);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const buttonListData = [
    { label: ScrollLabel.Next, value: ScrollPositionType.Next },
    { label: ScrollLabel.Prev, value: ScrollPositionType.Prev },
  ];

  const [popwinEl, setPopwinEl] = useState(null);


  useEffect(() => {
    if (synopsisInfo) {
      Promise.all(
        list.map((lists) => {
          const currentSplitType = (lists && lists.splitType) || SplitType.NO_SPLIT;
          if (currentSplitType === SplitType.MANUAL_SPLIT) {
            return ExtendedResourceRepository.getManualSplitHtml({
              bookId,
              filename: lists.src,
            });
          }
          return ExtendedResourceRepository.getJSONContent({
            bookId,
            pathName: lists.src,
          });
        })
      ).then((obj) => {
        setState({ synopsisList: obj.filter((item) => item) });
      });
    }
  }, [bookId, list, setState, synopsisInfo]);

  useEffect(() => {
    if (synopsisInfo && synopsisList.length > 0) {
      const allContent = synopsisList.map((obj, index) => {
        if (!obj) return '';
        const currentSplitType = (list[index] && list[index].splitType) || splitType;
        if (currentSplitType === SplitType.MANUAL_SPLIT) {
          return Object.values(obj).join('');
        }
        return obj.html || '';
      }).join('');
      setState({ template: allContent });
    } else {
      if (html) {
        if (splitType !== SplitType.MANUAL_SPLIT) {
          setState({ template: props.el.props.html });
        } else {
          setState({ template: Object.values(props.el.props.html).join('') });
        }
      }
    }
  }, [html, props.el.props, setState, synopsisInfo, synopsisList, list, splitType]);

  const hasClass = (el, cls) => {
    return (" " + el.className + " ").indexOf(" " + cls + " ") > -1;
  };

  const toggleShow = (id) => () => {
    const el = document.getElementById(id);
    if (el) {
      el.classList.toggle("show");
    }
  };

  const classToggleShow = () => {
    // 決定查詢範圍：shouldSplited 時嘗試限縮到當前頁面，否則用整個 document
    let scope = document;

    if (props.shouldSplited) {
      const pageElements = document.querySelectorAll('.synopsis-page');

      if (pageElements.length > 0 && currentPage >= 0 && currentPage < pageElements.length) {
        scope = pageElements[currentPage];
      } else {
        const textElements = document.querySelectorAll('.text');
        const contentElements = document.querySelectorAll('div.content');

        if (textElements.length > 0 && currentPage >= 0) {
          scope = textElements[currentPage] || textElements[0];
        } else if (contentElements.length > 0 && currentPage >= 0) {
          scope = contentElements[currentPage] || contentElements[0];
        }
      }
    }

    const selector = (schoolYear === false && semester === false) ? ".fill .ans" : ".ANSWERS";
    const cls = scope.querySelectorAll(selector);

    if (cls.length > 0) {
      const allShown = Array.from(cls).every(el => hasClass(el, "show"));
      for (let i = 0; i < cls.length; ++i) {
        if (allShown) {
          cls[i].classList.remove("show");
          cls[i].classList.remove("next");
        } else {
          cls[i].classList.add("show");
          cls[i].classList.add("next");
        }
      }
    }
  };

  const fontSizeChange = (fontSize) => () => {
      EventBus.emit({
        eventBusType,
        event: ReaderToolsEvent.ChangePopWindowFontSizeEvent,
        payload: { fontSize }
      });
    let el = [];
    const topic = document.getElementsByClassName("topic");
    // const wordSection = document.getElementsByClassName("word_section");
    const plainText = document.getElementsByClassName("plain_text");
    const fill = document.getElementsByClassName("fill");
    const imageSet = document.getElementsByClassName("imageSet");
    const simple = document.getElementsByClassName("simple");

    // 判斷從哪個題型進來
    if (topic.length > 0) {
      el = topic;
    } else if (plainText.length > 0) {
      el = plainText;
    } else if (fill.length > 0) {
      el = fill;
    } else if (imageSet.length > 0) {
      el = imageSet;
    } else if (simple.length > 0) {
      el = simple;
    }
    // else if (wordSection.length > 0) {
    //   el = wordSection;
    // } 

    for (let i = 0; i < el.length; i++) {
      if (el) {
        // 移除 class
        if (hasClass(el[i], "large")) {
          el[i].classList.remove("large");
        } else if (hasClass(el[i], "medium")) {
          el[i].classList.remove("medium");
        } else if (hasClass(el[i], "small")) {
          el[i].classList.remove("small");
        }

        // 根據 size 加入class
        // eslint-disable-next-line default-case

        const title=document.getElementsByClassName("title")[0]
        const imageSet=document.getElementsByClassName("imageSet")[0]
        const abreast=document.getElementsByClassName("abreast")[0]
        abreast.style.height=`${(1-title.clientHeight/imageSet.clientHeight)*100}%`
        switch (fontSize) {
          case "large":
            el[i].classList.add("large");
            break;
          case "medium":
            el[i].classList.add("medium");
            break;
          case "small":
            el[i].classList.add("small");
            break;
        }
      }
    }
  };

  const contentPositionHandler = (scrollDirection) => {
    // console.log("---1號按鈕---");
    EventBus.emit({
      eventBusType,
      event: ReaderToolsEvent.ChangePopWindowScrollPositionEvent,
      payload: { scrollPosition: scrollDirection },
    });

    const topic = document.getElementsByClassName("topic");
    const wordSection = document.getElementsByClassName("word_section");
    const plainText = document.getElementsByClassName("plain_text");
    const fill = document.getElementsByClassName("fill");
    const imageSet = document.getElementsByClassName("imageSet");
    const simple = document.getElementsByClassName("simple");

    // 判斷從哪個題型進來
    if (topic.length > 0) {
      setPopwinEl(topic);
      setContentDirection(ScrollDirection.Vertical);
    } else if (wordSection.length > 0) {
      setPopwinEl(wordSection);
      setContentDirection(ScrollDirection.Horizontal);
    } else if (plainText.length > 0) {
      setPopwinEl(plainText);
      setContentDirection(ScrollDirection.Vertical);
    } else if (fill.length > 0) {
      setPopwinEl(fill);
      setContentDirection(ScrollDirection.Vertical);
    } else if (imageSet.length > 0) {
      const text = imageSet[0].getElementsByClassName("text")
      setPopwinEl(text);
      setContentDirection(ScrollDirection.Vertical);
    } else if (simple.length > 0) {
      setPopwinEl(simple);
      setContentDirection(ScrollDirection.Vertical);
    }
  };

  useEffect(() => {
    if (contentDirection === ScrollDirection.Vertical) {
      // console.log("---A類小視窗---ExtendedContentButton---y", popwinEl);
      switch (scrollPosition) {
        case ScrollPositionType.Next: {
          for (let i = 0; i < (popwinEl || []).length; i++) {
            if (popwinEl) {
              setLastScrollTop(popwinEl[i].scrollTop);
              popwinEl[i].scrollTop += popwinEl[i].offsetHeight*ScrollLength;
              setCurrentScrollTop(popwinEl[i].scrollTop);
            }
          }
          break;
        }
        case ScrollPositionType.Prev: {
          for (let i = 0; i < (popwinEl || []).length; i++) {
            if (popwinEl) {
              setLastScrollTop(popwinEl[i].scrollTop);
              popwinEl[i].scrollTop -= popwinEl[i].offsetHeight*ScrollLength;
              setCurrentScrollTop(popwinEl[i].scrollTop);
            }
          }
          break;
        }
        default: {
          for (let i = 0; i < (popwinEl || []).length; i++) {
            scrollPositionButtonBehavior({currentScroll: currentScrollTop, lastScroll: lastScrollTop, coordinate: ScrollCoordinate.Y})
          }
          break;
        }
      }
    } else {
      // console.log("---A類小視窗---ExtendedContentButton---x", popwinEl);
      switch (scrollPosition) {
        case ScrollPositionType.Next: {
          for (let i = 0; i < (popwinEl || []).length; i++) {
            if (popwinEl) {
              setLastScrollLeft(popwinEl[i].scrollLeft);
              popwinEl[i].scrollLeft -= popwinEl[i].offsetWidth*ScrollLength;
              setCurrentScrollLeft(popwinEl[i].scrollLeft);
            }
          }
          break;
        }
        case ScrollPositionType.Prev: {
          for (let i = 0; i < (popwinEl || []).length; i++) {
            if (popwinEl) {
              setLastScrollLeft(popwinEl[i].scrollLeft);
              popwinEl[i].scrollLeft += popwinEl[i].offsetWidth*ScrollLength;
              setCurrentScrollLeft(popwinEl[i].scrollLeft);
            }
          }
          break;
        }
        default: {
          for (let i = 0; i < (popwinEl || []).length; i++) {
            scrollPositionButtonBehavior({currentScroll: currentScrollLeft, lastScroll: lastScrollLeft, coordinate: ScrollCoordinate.X})
          }
          break;
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentDirection, popwinEl, scrollPosition]);

  // 「答案」按鈕原本用 template.indexOf("='answer'") 判斷，是寫死單引號的字面比對。
  // 書本 HTML 的屬性引號寫法並不一致（同一份檔案裡 div 用單引號、img 用雙引號都有），
  // 一旦答案區寫成 id="answer" 或 id = 'answer'，比對就不中，按鈕靜默消失，
  // 而 #answer 本身還在畫面上。相對地「解析」用的是裸字串 "analyze"，所以會出現
  // 「有解析按鈕、沒有答案按鈕」的不對稱狀況（NBK-1662 追查時發現）。
  // 這裡先只放寬答案這一條，容許單雙引號與等號前後空白。
  // 註：四個按鈕都是字串比對，對引號／空白／屬性順序敏感，治本應改為對 parse 後的
  // DOM 查 #answer / #analyze / .ANSWERS / .fill，但那會影響所有延伸內容視窗，另案處理。
  const hasAnswerBlock = /id\s*=\s*['"]answer['"]/.test(template);

  return (
    <>
      {html || synopsisInfo  ? (
        <div className={styles.extendedContentButton}>
          {!props.shouldSplited && <div className={styles.left}>
            {(props.shouldSplited ? [...buttonListData].reverse() : buttonListData).map((item) => (
              <div
                className={`${styles.button} ${styles.scrollBtn}`}
                style={{backgroundColor: scrollPositionButtonState === item.stopSign && "gray"}}
                key={item.value}
                onMouseDown={() => {
                  contentPositionHandler(item.value);
                }}
                onMouseUp={() => {
                  contentPositionHandler(ScrollPositionType.None);
                }}
              >
                {item.label}
              </div>
            ))}

            <div className={classnames(styles.button, {[styles.active]: fontSize === "large"})} onClick={fontSizeChange("large")}>
              大
            </div>
            <div className={classnames(styles.button, {[styles.active]: fontSize === "medium"})} onClick={fontSizeChange("medium")}>
              中
            </div>
            <div className={classnames(styles.button, {[styles.active]: fontSize === "small"})} onClick={fontSizeChange("small")}>
              小
            </div>
          </div>}
          <div className={styles.right}>
            {schoolYear === false &&
            semester === false &&
            template.indexOf("='fill'") > -1 ? (
              <div className={styles.button} onClick={classToggleShow}>
                解答
              </div>
            ) : (
              ""
            )}
            {template.indexOf("ANSWERS") > -1 && (
              <div className={styles.button} onClick={classToggleShow}>
                解答
              </div>
            )}
            {hasAnswerBlock ? (
              <div className={styles.button} onClick={toggleShow("answer")}>
                答案
              </div>
            ) : (
              ""
            )}
            {template.indexOf("analyze") > -1 ? (
              <div className={styles.button} onClick={toggleShow("analyze")}>
                解析
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
